module.exports = {
  PRE_REQUISITION: 'PRE_REQUISITION',
  CREATED: 'CREATED',
  REQUISITION_APPROVED: 'REQUISITION_APPROVED',
  TEST_RESULTS_RECEIVED: 'TEST_RESULTS_RECEIVED',
  TEST_RESULTS_APPROVED: 'TEST_RESULTS_APPROVED'
}
